import { Injectable, Inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, combineLatest } from 'rxjs';
import { map, mergeMap, catchError, switchMap } from 'rxjs/operators';
import * as RunActions from './actions';
import { IRunManagementService } from '../../services/run-management/definitions';
import { RunManagementServiceToken } from '../../services/run-management/main';

@Injectable({
  providedIn: 'root',
})
export class RunManagementEffects {
  public constructor(
    private actions$: Actions,
    @Inject(RunManagementServiceToken)
    private runManagementService: IRunManagementService,
  ) {}

  public fetchRunsData$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RunActions.ActionTypes.FetchRunData),
      mergeMap(({ payload }) =>
        this.runManagementService.getAll(payload).pipe(
          map((runData) => new RunActions.FetchRunDataSuccess(runData)),
          catchError((error) => of(new RunActions.FetchRunDataFailure(error))),
        ),
      ),
    );
  });

  public fetchRunsExportData$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RunActions.ActionTypes.FetchRunExportData),
      mergeMap(({ payload }) =>
        this.runManagementService.export(payload).pipe(
          map((runData) => new RunActions.FetchRunExportDataSuccess(runData)),
          catchError((error) =>
            of(new RunActions.FetchRunExportDataFailure(error)),
          ),
        ),
      ),
    );
  });

  public updateRunStatus$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RunActions.ActionTypes.UpdateRunStatus),
      mergeMap(({ payload }) =>
        this.runManagementService.updateRunStatus(payload).pipe(
          map(() => new RunActions.RunStatusUpdateSuccess(payload)),
          catchError((error) =>
            of(new RunActions.RunStatusUpdateFailure(error)),
          ),
        ),
      ),
    );
  });

  public updateMultipleRunStatus$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RunActions.ActionTypes.UpdateMultipleRunStatus),
      mergeMap(({ payload }) =>
        combineLatest([
          this.runManagementService.updateRunStatus(payload[0]),
          this.runManagementService.updateRunStatus(payload[1]),
        ]).pipe(
          switchMap((res) => {
            return [
              new RunActions.RunStatusUpdateSuccess(payload[0]),
              new RunActions.RunStatusUpdateSuccess(payload[1]),
            ];
          }),
          catchError((error) =>
            of(new RunActions.RunStatusUpdateFailure(error)),
          ),
        ),
      ),
    );
  });

  public updateRunNote$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RunActions.ActionTypes.UpdateRunNote),
      mergeMap(({ payload }) =>
        this.runManagementService.updateRunNote(payload).pipe(
          map(() => new RunActions.RunNoteUpdateSuccess(payload)),
          catchError((error) => of(new RunActions.RunNoteUpdateFailure(error))),
        ),
      ),
    );
  });
}
